import DashboardSectionProps from "features/dashboard/models/DashboardSectionProps";
import DashboardCustomerSection from './DashboardCustomerSection';
import DashboardInvoicesSection from './DashboardInvoicesSection';
import DashboardRequirementsSection from './DashboardRequirementsSection';
import DashboardPaymentsSection from './DashboardPaymentsSection';
import DashboardMeasuredDataSection from './DashboardMeasuredDataSection';

interface ComponentMap {
  [key: string]: (props: DashboardSectionProps) => JSX.Element | null;
}

export const DashboardSectionTypesMap: ComponentMap  = {
  "Customer": DashboardCustomerSection,
  "Requirements": DashboardRequirementsSection,
  "Invoices": DashboardInvoicesSection,
  "Payments": DashboardPaymentsSection,
  "MeasuredData": DashboardMeasuredDataSection
}